import React, { useEffect, useState } from 'react';
import { Header, Pagination, Placeholder, Table } from 'react-frontier';
import { EventShortInfo } from '../../ReportsClasses';
import { addCommas } from '@arema/components/Util';
import { LoadError } from '../../components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import API from '../../ReportsAPI';

const INNACTIVE_COUNT = 20;

interface EventStatsDatesProps{
	event: EventShortInfo
}

interface EventDateStats{
	date_id: number,
	date: number,
	sales: number,
	tickets: number,
}

interface EventDateData{
	active: number,
	innactive: number,
	dates: {
		active: EventDateStats[],
		innactive: EventDateStats[],
	}
}

const PlaceholderRow : JSX.Element[] = [
	<Placeholder width={40} random={false} />,
	<Placeholder />,
	<Placeholder width={50} />,
	<Placeholder width={40} />,
]

var StatRow = (a: EventDateStats)=>{
	return <Table.Row compact as={Link} to={`funciones/${a.date_id}`} key={`STR-${a.date_id}`} collapsingIndexes={[0,2,3]} data={[
		a.date_id,
		moment.unix(a.date).format('DD/MMM/YY HH:mm'),
		addCommas(a.tickets, false),
		`$${addCommas(a.sales)}`
	]} />
}

var EventStatsDates = (props: EventStatsDatesProps)=>{
	var { t } = useTranslation();
	var [dates, setDates] = useState<EventDateData>(null);
	var [hasMore, setHasMore] = useState<boolean>(false);
	var [loadError, setLoadError] = useState<string>(null);
	var [pageError, setPageError] = useState<string>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);
	var [pageDates, setPageDates] = useState<EventDateStats[]>(null);

	useEffect(()=>{
		if(dates) return;
		API.getEventDates(props.event.event_id, INNACTIVE_COUNT).then(res=>{
			if(res.error) return setLoadError(res.message);
			setDates(res.data);
			if(res.data && res.data.innactive>INNACTIVE_COUNT){
				setHasMore(true);
			}
		}).catch(err=>{
			setLoadError(t('common.error_code', { type: 'cargando las funciones del evento', code: 'LCL-1' }));
		});
	}, []);

	var onPageChange = (page: number)=>{
		setPage(page);
		if(page>0){
			setLoading(true);
			API.getInnactiveDates(props.event.event_id, INNACTIVE_COUNT*page, INNACTIVE_COUNT).then(res=>{
				if(res.error) return setPageError(res.message);
				setPageDates(res.data);
			}).catch(err=>{
				setLoadError(t('common.error_code', { type: 'cargando las fechas inactivas', code: 'LCL-2' }));
			}).finally(()=>{
				setLoading(false);
			})
		}
	}
	
	return <div className="ar event-stats-dates-screen">
		<Header text={props.event.event_name} subtext={t('dates.title')} style={{ marginTop: 15 }} />
		{loadError ? (
			<LoadError text={loadError} />
		) : (
			<Table
				striped
				selectable
				title={t('dates.title')}
				style={{ maxWidth: 700, margin: 'auto', marginTop: 15 }}
				footer={hasMore && (
					<Table.Cell row colSpan={4} style={{ textAlign: 'right' }}>
						<Pagination disabled={loading} page={page} onPageChange={onPageChange} pageCount={Math.ceil(dates.innactive/INNACTIVE_COUNT)} />
					</Table.Cell>
				)}
			>
				{dates ? <>
					{dates.active>0 ? <>
						<Table.Row selectable={false} collapsingIndexes={[0,2,3]} header data={t('dates.headers', { returnObjects: true }) as string[]} />
						{dates.dates.active.map(StatRow)}
					</> : (
						<Table.Row selectable={false}>
							<Table.Cell colSpan={4}>
								<Header text={t('dates.empty.title')} subtext={t('dates.empty.text')} />
							</Table.Cell>
						</Table.Row>
					)}
					{dates.innactive>0 && <>
						<Table.Row header selectable={false}>
							<Table.Cell style={{ fontSize: 16 }} colSpan={4}>{t('dates.innactive_dates')}</Table.Cell>
						</Table.Row>
						<Table.Row selectable={false} collapsingIndexes={[0,2,3]} header data={t('dates.headers', { returnObjects: true }) as string[]} />
						{loading ? (
							<Table.Row selectable={false}>
								<Table.Cell colSpan={4}>
									<Header loading text={t('dates.loading')} />
								</Table.Cell>
							</Table.Row>
						) : page==0 ? (
							dates.dates.innactive.map(StatRow)
						) : pageError ? (
							<Table.Row selectable={false}>
								<Table.Cell colSpan={4}>
									<Header text={t('common.error')} subtext={pageError} />
								</Table.Cell>
							</Table.Row>
						) : (
							pageDates.map(StatRow)
						)}
					</>}
				</> : <>
					<Table.Row collapsingIndexes={[0,2,3]} data={PlaceholderRow} />
					<Table.Row collapsingIndexes={[0,2,3]} data={PlaceholderRow} />
					<Table.Row collapsingIndexes={[0,2,3]} data={PlaceholderRow} />
					<Table.Row collapsingIndexes={[0,2,3]} data={PlaceholderRow} />
				</>}
			</Table>
		)}
	</div>
}

export default EventStatsDates;